class Megamenu extends HTMLElement {
  constructor() {
    super();
    this.currentHoveredItem = null;
  }

  connectedCallback() {
    if (!this.isAddedToHeader()) {
      this.addMeganavToHeader();
      this.setupEventListeners();
    }
  }

  isAddedToHeader() {
    return document.querySelector('.header-wrapper megamenu-nav') !== null;
  }

  addMeganavToHeader() {
    const headerWrapper = document.querySelector('.section-header .header-wrapper');
    headerWrapper.appendChild(this);
  }

  setupEventListeners() {
    document.querySelectorAll('.nav-target').forEach((navTarget) => {
      navTarget.addEventListener('mouseover', (event) => this.handleMouseOver(navTarget, event));
      this.setupToggle(navTarget);
    });

    document.addEventListener('mouseover', (event) => this.hideMenuItems(event));
  }

  handleMouseOver(navTarget, event) {
    const targetValue = navTarget.getAttribute('data-item-handle');
    const modifiedTargetValue = `megamenu-${targetValue}`;
    const relatedMegamenuItem = this.querySelector(`megamenu-item[id="${modifiedTargetValue}"]`);

    if (this.currentHoveredItem && this.currentHoveredItem !== relatedMegamenuItem) {
      this.currentHoveredItem.classList.remove('is_visible');
      document.body.classList.remove('megamenu-is-active');
      this.setExpanded(this.currentHoveredItem, false);
    }

    if (relatedMegamenuItem) {
      relatedMegamenuItem.classList.add('is_visible');
      document.body.classList.add('megamenu-is-active');
      this.currentHoveredItem = relatedMegamenuItem;
      this.setExpanded(relatedMegamenuItem, true);
    } else {
      this.currentHoveredItem = null; // Reset the current hovered item
    }

    event.stopPropagation();
  }

  hideMenuItems(event) {
    const headerWrap = document.querySelector('.header-wrap');
    const megamenuCurtain = document.querySelector('megamenu-curtain');
    const isOutsideHeaderWrap = !headerWrap.contains(event.target);
    const megamenuItems = this.querySelectorAll('megamenu-item.is_visible');
    if (isOutsideHeaderWrap && megamenuItems || event.target == megamenuCurtain ) {
      megamenuItems.forEach((item) => {
        if (item.classList.contains('is_visible')) {
          item.classList.remove('is_visible');
          document.body.classList.remove('megamenu-is-active');
          this.currentHoveredItem = null; // Reset the current hovered item
          this.setExpanded(item, false);
        }
      });
    }
  }

  setupToggle(navTarget) {
    const toggle = navTarget.parentElement.querySelector('.megamenu-toggle');
    if (!toggle) return;
    const panel = this.querySelector(`megamenu-item[id="megamenu-${navTarget.getAttribute('data-item-handle')}"]`);
    if (!panel) {
      toggle.remove();
      return;
    }
    toggle.setAttribute('aria-controls', panel.id);
    toggle.addEventListener('mouseover', (event) => this.handleMouseOver(navTarget, event));
    toggle.addEventListener('click', (event) => {
      if (event.detail === 0 && panel.classList.contains('is_visible')) {
        this.closePanel(panel);
      } else {
        this.openPanel(panel);
      }
    });
    toggle.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closePanel(panel);
      } else if (event.key === 'Tab' && !event.shiftKey && panel.classList.contains('is_visible')) {
        const first = this.getFocusable(panel)[0];
        if (first) {
          event.preventDefault();
          first.focus();
        }
      }
    });
    panel.addEventListener('keydown', (event) => this.onPanelKeydown(event, panel, toggle));
    [toggle, panel].forEach((element) => {
      element.addEventListener('focusout', (event) => {
        const next = event.relatedTarget;
        if (!next || next === toggle || panel.contains(next)) return;
        this.closePanel(panel);
      });
    });
  }

  onPanelKeydown(event, panel, toggle) {
    if (event.key === 'Escape') {
      this.closePanel(panel);
      toggle.focus();
      return;
    }
    if (event.key !== 'Tab') return;
    const items = this.getFocusable(panel);
    if (event.shiftKey && event.target === items[0]) {
      event.preventDefault();
      toggle.focus();
    } else if (!event.shiftKey && event.target === items[items.length - 1]) {
      const header = document.querySelector('.header-wrapper');
      const headerItems = this.getFocusable(header).filter((element) => !this.contains(element));
      const next = headerItems[headerItems.indexOf(toggle) + 1];
      if (next) {
        event.preventDefault();
        this.closePanel(panel);
        next.focus();
      }
    }
  }

  getFocusable(container) {
    return Array.from(
      container.querySelectorAll("summary, a[href], button:enabled, input:enabled, select:enabled, textarea:enabled, [tabindex]:not([tabindex^='-'])")
    ).filter((element) => element.getClientRects().length > 0);
  }

  openPanel(panel) {
    if (this.currentHoveredItem && this.currentHoveredItem !== panel) this.closePanel(this.currentHoveredItem);
    panel.classList.add('is_visible');
    document.body.classList.add('megamenu-is-active');
    this.currentHoveredItem = panel;
    this.setExpanded(panel, true);
  }

  closePanel(panel) {
    panel.classList.remove('is_visible');
    if (this.currentHoveredItem === panel) this.currentHoveredItem = null;
    if (!this.querySelector('megamenu-item.is_visible')) document.body.classList.remove('megamenu-is-active');
    this.setExpanded(panel, false);
  }

  setExpanded(panel, expanded) {
    document.querySelectorAll(`.megamenu-toggle[aria-controls="${panel.id}"]`).forEach((toggle) => {
      toggle.setAttribute('aria-expanded', String(expanded));
    });
  }
}

customElements.define('megamenu-nav', Megamenu);
